import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/pricing-rules')({
  component: () => <RouteGuard route="/pricing-rules" />,
});
